import { Record } from "immutable";

const AttrResultRecord = Record({
  id: null,
  surveyResultId: null,
  surveyAttrId: null,
  attrItemId: null
});

class AttrResult extends AttrResultRecord {}

export default AttrResult;



// WEBPACK FOOTER //
// ./src/models/AttrResult.js